import React from 'react';
import { Container } from '@mui/material';
import MyProfileForm from '../components/MyProfile/MyProfileForm';

const MyProfile: React.FC = () => {
  return (
    <Container>
      <MyProfileForm />
    </Container>
  );
};

export default MyProfile;
